import CustomerInfoSection from './CustomerInfoSection';
import InvoiceInfoSection from './InvoiceInfoSection';
import PaymentInfoSection from './PaymentInfoSection';
import RememberMeSection from './RememberMeSection';

export default {
  CustomerInfoSection,
  InvoiceInfoSection,
  PaymentInfoSection,
  RememberMeSection,
};
